import { firstCountryMatchingPrefix } from '../constants/countries';

/** Clears the typed buffer after this idle gap (ms). */
export const COUNTRY_TYPEAHEAD_RESET_MS = 700;

/**
 * Append a key to the typeahead buffer and return the first country match.
 * Callers should preventDefault on letter keys so native select does not
 * jump unpredictably between the first and last match.
 */
export function matchCountryTypeaheadKey(
  buffer: string,
  key: string,
  countries?: readonly string[]
): { nextBuffer: string; match: string | undefined } {
  if (key.length !== 1 || !/[a-zA-Z]/.test(key)) {
    return { nextBuffer: buffer, match: undefined };
  }
  const nextBuffer = `${buffer}${key.toLowerCase()}`;
  return {
    nextBuffer,
    match: firstCountryMatchingPrefix(nextBuffer, countries),
  };
}
